import { UserRole } from '../../../components/common/header/photo/head-bar/newsComponent/utils/userRoleHelper';

export type PreviewAudienceInput = {
    previewRole: UserRole;
    recipientRoles: UserRole[];
    startDate: string | null;
    endDate: string | null;
    brokerChainCount: number;
};

export type PreviewAudience =
    | { kind: 'no-recipients' }
    | { kind: 'not-recipient' }
    | { kind: 'no-dates' }
    | { kind: 'shown'; from: string; until: string | null; brokerChainCount: number | null };

export function getPreviewAudience(input: PreviewAudienceInput): PreviewAudience {
    if (input.recipientRoles.indexOf(input.previewRole) === -1) {
        return { kind: 'not-recipient' };
    }

    if (!input.startDate) {
        return { kind: 'no-dates' };
    }

    return {
        kind: 'shown',
        from: input.startDate,
        until: input.endDate,
        brokerChainCount: input.previewRole === UserRole.BrokerAgent ? input.brokerChainCount : null
    };
}

export type ScheduleAudienceInput = {
    recipientRoles: UserRole[];
    startDate: string | null;
    endDate: string | null;
    brokerChainCount: number;
};

export function getScheduleAudience(input: ScheduleAudienceInput): PreviewAudience {
    if (input.recipientRoles.length === 0) {
        return { kind: 'no-recipients' };
    }

    const roleWithChainLimitIfChosen =
        input.recipientRoles.indexOf(UserRole.BrokerAgent) !== -1
            ? UserRole.BrokerAgent
            : input.recipientRoles[0];

    return getPreviewAudience({ ...input, previewRole: roleWithChainLimitIfChosen });
}
